<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">お問い合わせ・FAQ</div>
      </md-card-header>

      <md-card-content>
        <a href="#" @click="backToList()">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>
      </md-card-content>

      <loading-spinner v-if="loadDetail"></loading-spinner>
      <md-card-content v-else-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          <form @submit.prevent="submitForm" novalidate>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>カテゴリ名</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('name')">
                    <label>カテゴリ名</label>
                    <md-input v-model="form.name" required :disabled="sending"/>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('name')">{{
                        getValidationResponseMessage('name')
                      }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.name.required">{{ errors.name.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.name.maxLength">{{ errors.name.maxLength }}</span>
                  </md-field>
                </div>
              </div>
            </md-card-content>
            <md-card-actions class="md-layout md-alignment-center-center">
              <md-button :disabled="sending" class="md-raised md-primary" type="submit">
                <md-icon>save</md-icon>
                <span>登録する</span>
              </md-button>
            </md-card-actions>
          </form>
        </div>
      </div>
    </md-card>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false" :disabled="sending">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
import 'vue-datetime/dist/vue-datetime.css'
import {validationMixin}                                 from 'vuelidate'
import {maxLength, required,}                            from 'vuelidate/lib/validators'
import {mapActions}                                      from 'vuex';
import FlashMessage                                      from '../../../components/FlashMessage';
import LoadingSpinner                                    from '../../../components/LoadingSpinner';
import {apiClientWithManagerToken as apiClient, apiList} from '../../../modules/apiClient';
import Common                                            from '../../../modules/common';
import Validation                                        from '../../../modules/validation';
import CommonMixin                                       from '../../../mixins/commonMixin';

export default {
  name      : "BackendAdminFaqCategoryNew",
  components: {
    FlashMessage,
    LoadingSpinner,
  },
  mixins    : [CommonMixin, validationMixin],
  props     : {
    id: String
  },
  data      : () => ({
    loadDetail      : false,
    categoryId      : null,
    errorMessages   : [],
    validateResponse: [],
    editor          : null,
    form            : {
      name: null,
    },
    errors          : {
      name: {
        required : Validation.errorMessage(Validation.rules.required, 'name'),
        maxLength: Validation.errorMessage(Validation.rules.maxLength, 'name', 255),
      },
    },
  }),
  validations() {
    return {
      form: {
        name: {
          required,
          maxLength: maxLength(255),
        },
      },
    };
  },
  mounted: function () {
    if (this.$props.id) {
      this.categoryId = this.$props.id;
      this.getFaqCategoryDetail();
    } else {
      this.fetchDetail = true;
    }
  },
  methods: {
    ...mapActions('adminFaqs', [
      'saveBack',
    ]),
    backToList() {
      this.saveBack(true);
      this.$router.replace({name: 'BackendAdminFaqs'}).then();
    },
    errorNotFound() {
      if (this.$props.id) {
        if (!this.categoryId) {
          this.errorMessages = [Common.messages.faqCategoryEdit.notFound];
          return true;
        }
      }
      return false;
    },
    getFaqCategoryDetail() {
      this.successMessage = null;
      this.sending        = true;
      this.loadDetail     = true;
      const detailUrl     = apiList.faqCategory.detail.replace(':id', this.categoryId);
      apiClient.get(detailUrl)
          .then(response => {
            const result = response.data;
            if (result.errors) {
              this.categoryId    = null;
              this.errorMessages = result.errors;
              return;
            }
            this.form.name = result.name;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending     = false;
            this.loadDetail  = false;
            this.fetchDetail = true;
          });
    },
    updateFaqCategory() {
      this.sending          = true;
      this.validateResponse = [];
      const url             = apiList.faqCategory.update.replace(':id', this.categoryId);
      apiClient.put(url, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (this.categoryId) {
              this.setSnackBar(Common.messages.faqCategoryEdit.updateSuccess);
              this.backToList();
            } else {
              this.errorMessages = [Common.messages.faqCategoryEdit.updateError];
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
    },
    registerFaqCategory() {
      this.sending          = true;
      this.validateResponse = [];
      apiClient.post(apiList.faqCategory.register, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }

            this.categoryId = null;
            this.setSnackBar(Common.messages.faqCategoryEdit.registerSuccess);
            this.backToList();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
    },
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.$props.id) {
          this.updateFaqCategory();
        } else {
          this.registerFaqCategory();
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
